// @flow

import React from 'react'
import { Container } from '../../basic/Grid'
import classNames from 'classnames'
import { applyStylingHoc, type StyleOuterProps, type StyleProps } from '@fcse/tsbob/dist/lib/styling'
import baseStyles from './Requirements.scss'

type Props = {
  ...StyleProps,
  requirements: Object,
  image: Object,
  imgAlt: any,
  title: string,
  id?: string,
  reversed?: boolean
}

const Requirements = ({
  styles, requirements, title, id, image, reversed
}: Props) => (
  <Container className={classNames(styles.root, reversed && styles['is-reversed'])} fluid>
    <div className={styles.imgContainer}>
      {image}
    </div>
    <div className={styles.content} id={id}>
      <h3 className={styles.title}>{title}</h3>
      <ul className={styles.list}>
        {requirements.map((text, index) => (
          <li key={index} className={styles.listItem}>
            {text}
          </li>
        ))}
      </ul>
    </div>
  </Container>
)

export default
applyStylingHoc(baseStyles)<$Diff<Props, StyleProps> & StyleOuterProps, Function>(Requirements)
